import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAllMASTERPT_PRIORITY = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY + `/getAll`);
};
export const getAllMASTERPT_PRIORITY_BYID = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY + `/pt/${id}`);
};
export const getAllMASTERPT_PRIORITY_BYIDTM = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY + `/tm/${id}`);
};



export const createMASTERPT_PRIORITY = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY, data);
};

export const updateMASTERPTPRIORITY = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY + `/${id}`, data);
};

export const deleteMASTERPTPRIORITY = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.MASTERPT_PRIORITY + `/${id}`);
};